import React, { useContext } from "react"; //
import {
  //
  bearlog,
  BearDiv,
  BearTextMedia,
} from "@sillyscribe95/bear-ui-web";
import { PopList } from "./GlobalComps";
import { instConst } from "../consts/instConst";
import { MainContext } from "../context/MainContext";

export function InstChoose() {
  const {
    //
    isnSound,
    setisnSound,
  } = useContext(MainContext);

  const weae = {};

  function asdfas(zxcvds) {
    const { itemName } = zxcvds;
    bearlog.lug("___ asdfas ___", zxcvds);

    setisnSound(itemName);
  }

  const nsdsdfa = {
    // weae:
    dictvar: instConst,
    selected: {
      noSelect: true,
      ...instConst[isnSound],
    },
    // itemStyle: { minWidth: "100px" },
    bearName: "asdasd",
    list: Object.keys(instConst),
    renderItem: asdfqas,
    onClick: asdfas,
  };

  function asdfqas({ noSelect, itemName, icon }) {
    let oasdwe = noSelect
      ? icon
      : BearTextMedia({
          //   swapItems: "as",
          iconvar: icon,
          textvar: itemName,
        });

    let dbsfdgds =
      //
      //   icon;
      oasdwe;

    //
    return dbsfdgds;
  }

  return PopList(nsdsdfa);
}
